const isServer = typeof window === "undefined"

// cannot use dynamic variable names in Next.js config files

export default function getOktaConfig(preview = false) {
    if (preview) {
        return isServer
            ? {
                  issuer: process.env.OKTA_ISSUER_PREVIEW,
                  org: process.env.OKTA_ORG_URL_PREVIEW,
                  apiToken: process.env.OKTA_API_TOKEN_PREVIEW,
                  clientSecret: process.env.OKTA_CLIENT_SECRET_PREVIEW,
                  regClientId: process.env.OKTA_REG_CLIENT_ID_PREVIEW,
                  regClientSecret: process.env.OKTA_REG_CLIENT_SECRET_PREVIEW,
              }
            : {
                  issuer: process.env.NEXT_PUBLIC_OKTA_ISSUER_PREVIEW,
                  org: process.env.NEXT_PUBLIC_OKTA_ORG_URL_PREVIEW,
                  regClientId: process.env.NEXT_PUBLIC_OKTA_REG_CLIENT_ID_PREVIEW,
              }
    }

    return isServer
        ? {
              issuer: process.env.OKTA_ISSUER,
              org: process.env.OKTA_ORG_URL,
              apiToken: process.env.OKTA_API_TOKEN,
              clientId: process.env.OKTA_CLIENT_ID,
              clientSecret: process.env.OKTA_CLIENT_SECRET,
              regClientId: process.env.OKTA_REG_CLIENT_ID,
              regClientSecret: process.env.OKTA_REG_CLIENT_SECRET,
          }
        : {
              issuer: process.env.NEXT_PUBLIC_OKTA_ISSUER,
              org: process.env.NEXT_PUBLIC_OKTA_ORG_URL,
              clientId: process.env.NEXT_PUBLIC_OKTA_CLIENT_ID,
              regClientId: process.env.NEXT_PUBLIC_OKTA_REG_CLIENT_ID,
          }
}
